














































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class Home extends Vue {
	private link = [
		{
			text: 'github',
			href: 'https://github.com/kagechan5',
		},
		{
			text: '研究室',
			href: 'https://www.sens.sys.es.osaka-u.ac.jp/',
		},
	];
}
